import { render, staticRenderFns } from "./InsideDocument.vue?vue&type=template&id=23790287&scoped=true&"
import script from "./InsideDocument.vue?vue&type=script&lang=js&"
export * from "./InsideDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23790287",
  null
  
)

export default component.exports